import React, { useState, useEffect, useContext } from 'react';
import { store as mainStore } from '../../../../../../store';
import LineChart from '../../../../../../components/Charts/LineChart';
import { makeStyles } from '@material-ui/core/styles';
import DatePicker from '../../../../../../components/TextFields/DatePicker';
import Button from '../../../../../../components/Button/ProgressiveButton';
import SearchIcon from '@material-ui/icons/Search';
import moment from 'moment-jalaali';
import axios from '../../../../../../api/axios';
import { __ } from '../../../../../../utils/i18n';
import { isMobile } from 'react-device-detect';
import { useMutation, useQuery } from 'react-query';

moment.locale('fa');

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexFlow: 'column nowrap',
    '& > *:not(:last-child)': {
      marginBottom: theme.spacing(1),
    },
  },
  form: {
    display: 'grid',
    gridTemplateColumns: isMobile ? '1fr 1fr' : '150px 150px 150px',
    gridGap: theme.spacing(1),
  },
}));

const OrdersChart = () => {
  const classes = useStyles();
  const { showMessage, showError } = useContext(mainStore);
  const initialOptions = {
    title: {
      text: 'سفارشات',
    },
    chart: {
      style: {
        fontFamily: 'IRANSans',
      },
      marginBottom: 100,
    },
    subtitle: {
      text: 'تعداد سفارشات در وضعیت های متفاوت',
    },

    yAxis: {
      title: {
        text: 'تعداد',
      },
    },

    xAxis: {
      accessibility: {
        rangeDescription: 'Range: 1 to 31',
      },
      categories: null,
    },

    legend: {
      align: 'center',
      verticalAlign: 'bottom',
      x: 0,
      y: 0,
    },

    plotOptions: {
      series: {
        label: {
          connectorAllowed: false,
        },
        lineWidth: 3,
      },
    },
    series: null,
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 500,
          },
          chartOptions: {
            legend: {
              layout: 'vertical',
              align: 'center',
              verticalAlign: 'bottom',
            },
          },
        },
      ],
    },
  };
  const [options, setOptions] = useState(initialOptions);
  const startDate = moment().startOf('month');
  const endDate = moment();
  const [range, setRange] = useState({ start: startDate, end: endDate });
  const { start, end } = range;
  const [progress, setProgress] = useState(true);

  const allStatusesReport = async () => {
    try {
      setProgress(true);
      const { data } = await axios.post(
        `/api/v1/admin/reports/charts/allStatuses`,
        {
          start,
          end,
        }
      );
      if (data?.ok) {
        const translated = data.series?.map((s) => ({
          ...s,
          name: __(s.name),
        }));
        setOptions({
          ...options,
          series: translated || [],
          xAxis: { ...options.xAxis, categories: data?.labels || '' },
        });
      }
      return data;
    } catch (error) {
      showError(error);
    } finally {
      setProgress(false);
    }
  };

  const { data } = useQuery('loadAllStatusesReport', allStatusesReport, {
    cacheTime: 24 * 60 * 60 * 1000,
  });

  const handleChangeStartDate = (date) => {
    setRange({ ...range, start: date });
  };
  const handleChangeEndDate = (date) => {
    setRange({ ...range, end: date });
  };

  const { mutate } = useMutation(allStatusesReport, {
    onMutate: () => setProgress(true),
    onSuccess: () => setProgress(false),
  });

  const handleClick = () => {
    mutate();
  };

  return (
    <div className={classes.root}>
      <div className={classes.form}>
        <DatePicker
          label="از تاریخ"
          value={start}
          onChange={handleChangeStartDate}
          disabled={progress}
        />
        <DatePicker
          label="تا تاریخ"
          value={end}
          onChange={handleChangeEndDate}
          disabled={progress}
        />
        <Button
          onClick={handleClick}
          variant="contained"
          color="secondary"
          endIcon={<SearchIcon />}
          disabled={progress}
        >
          نمایش
        </Button>
      </div>
      <LineChart options={options} loading={progress} />
    </div>
  );
};

export default React.memo(OrdersChart);
